export const CANCELLATION_REASON_TYPES = {
    UPGRADE: 'שדרוג מינוי',
    CHANGE_SUBSCRIPTION: 'שינוי מינוי',
    MISTAKE: 'טעות בבחירת המינוי',
    CUSTOMER_REQUEST: 'לבקשת הלקוח',
    DENIAL_OF_TRANSACTION: 'הכחשת עסקה',
    STO_CANCELLED: 'ביטול הוראת קבע',
    RETURNED_CHARGE: 'חיוב חוזר',
    BLOCKING_PAYMENT_METHOD: 'חסימת אמצעי תשלום',
    RIP: 'פטירת לקוח',
    OTHER: 'סיבה אחרת'
}

export const CANCELLATION_STATUS_TYPES = {
    OPEN: 'בקשה פתוחה',
    IN_PROGRESS: 'בטיפול',
    CLOSED: 'בקשה סגורה',
    HANDLE_REQUIRE: 'נדרש טיפול',
    FUTURE_CANCELLATION: 'ביטול עתידי',
    // Set by the Galil flow (from OPEN) or the admin modal (from OPEN, HANDLE_REQUIRE or FUTURE_CANCELLATION);
    // never a plain status-menu target.
    AWAITING_PAYMENT: 'ממתין לתשלום'
}

export const CANCELLATION_STATUS_COLORS = {
    OPEN: 'red',
    IN_PROGRESS: '#ffb033',
    CLOSED: 'green',
    HANDLE_REQUIRE: '#f5222d',
    FUTURE_CANCELLATION: '#1890ff',
    AWAITING_PAYMENT: '#722ed1'
}

// plural phrasing, used only in the filter dropdown
export const CANCELLATION_STATUS_FILTER_LABELS = {
    OPEN: 'בקשות פתוחות',
    IN_PROGRESS: 'בקשות בטיפול',
    CLOSED: 'בקשות סגורות',
    // Singular phrasing is intentional per the product decision.
    HANDLE_REQUIRE: 'נדרש טיפול',
    FUTURE_CANCELLATION: 'ביטולים עתידיים'
}

export const FUTURE_CANCELLATION_DATE_LABEL = 'תאריך ביטול עתיד'

export const SERVICE_PROVIDED_DATE_LABEL = 'תאריך צריכת שירות'

// Stable `reason_code` the API adds to a cancellation request's message entry when the deferred-cancellation
// run could not determine the standing-order state because Tranzila (or its report) failed. Older API versions
// send no code; their entries (and any unknown code) keep showing the stored `msg` untouched.
export const TRANZILA_STO_LOOKUP_UNAVAILABLE = 'TRANZILA_STO_LOOKUP_UNAVAILABLE'

export const TRANZILA_STO_LOOKUP_UNAVAILABLE_TEXT = 'טרנזילה אינה זמינה כרגע. נדרשת בדיקה ידנית.'

// What the messages popup shows for one entry. For the coded entry the approved sentence comes FIRST and the
// complete stored `msg` (execution steps included) stays underneath, untouched; every other entry is just its `msg`.
export const cancellationMessageParts = (entry: any): { lead: string | null; body: string } => {
    const body = entry && typeof entry.msg === 'string' ? entry.msg : ''
    if (entry && entry.reason_code === TRANZILA_STO_LOOKUP_UNAVAILABLE) {
        return { lead: TRANZILA_STO_LOOKUP_UNAVAILABLE_TEXT, body }
    }
    return { lead: null, body }
}
